// this is an autogenerated file from App/Account/Content/Settings/Content/Procedures/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_Procedures_Content($location_id: numeric!) {
  vaxiom_procedures(
    where: { organization_id: { _eq: $location_id } }
    order_by: { name: asc }
  ) {
    id
    name
    description
    requires_diagnosis
    requires_images
    sys_created
    sys_last_modified
    charges: procedure_misc_fee_charge_templates {
      procedure_id
      misc_fee_charge_template_id
    }
  }
}

`